import usePortalQuery from 'src/Libs/api/hooks/use-portal-query'
import { ChartPriceItem } from 'src/Libs/dynamic-power-prices/types'
import { fetchFeedInPrices } from 'src/Libs/dynamic-power-prices/api/power-price.api'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { convertPriceData, removeOutOfRangePrices } from '../utils'

interface Props {
  installationId: string | undefined
  /* The time range for which to fetch electricity prices */
  from: Date
  to: Date
}

/**
 * hook for fetching feed-in prices for AI360.
 * it fetches data for a specific installation and time range.
 */
export const useAI360FeedInPrices = ({ installationId, from, to }: Props): ChartPriceItem[] => {
  const authFetch = useAuthFetchWithResponse()

  /* Convert moment-dates to ISO strings for reliable query keys */
  const fromISO = from.toISOString()
  const toISO = to.toISOString()

  const { data: feedInPrices } = usePortalQuery({
    queryKey: ['ai360-feed-in-prices', installationId, fromISO, toISO],
    queryFn: () => fetchFeedInPrices(installationId, from, to, authFetch),
    enabled: !!installationId && !!from && !!to,
  })

  const validFeedInPrices = removeOutOfRangePrices(feedInPrices ?? [], from, to)
  const feedInPriceData = convertPriceData({ priceData: validFeedInPrices, from, to })

  return feedInPriceData ?? []
}
